var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHillside = function SvgHillside(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 463,
    height: 119,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B6DF5D",
    d: "M148 1C-25.417 1-72 34.25-166 97.103c0 0 89.5 21.897 314 21.897s314-21.897 314-21.897C365.5 39.523 321.417 1 148 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M462 97C365.5 39.481 321.417 1 148 1S-72 34.215-166 97"
  })));
};
export default SvgHillside;